import { render, staticRenderFns } from "./IconClose.vue?vue&type=template&id=9b38bb24&scoped=true&"
import script from "./IconClose.vue?vue&type=script&lang=js&"
export * from "./IconClose.vue?vue&type=script&lang=js&"
import style0 from "./IconClose.vue?vue&type=style&index=0&id=9b38bb24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b38bb24",
  null
  
)

export default component.exports